if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends HTMLElement {
      constructor() {
        super();

        this.zoomistInitialized = false;
        this.slider = this.querySelector('aw-slider');
        this.closeTrigger = this.querySelector('.product__modal-close');
        this.triggers = document.querySelectorAll('.product__swiper--gallery .product__image');

        this.setListeners();
      }

      setListeners() {
        this.triggers.forEach(trigger => {
          trigger.addEventListener('click', e => {
            const index = trigger.closest('.product__slide').dataset.index;

            this.slider.swiper.slideTo(index);
            setTimeout(() => this.open(), this.slider.swiper.params.speed);
          });
        });

        this.closeTrigger.addEventListener('click', e => {
          e.preventDefault();
          this.close();
        });

        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' || event.key === 'Esc') {
            this.close();
          }
        });
      }

      open() {
        if (!this.zoomistInitialized) {
          this.zoomist();
        }

        pauseAllMedia();
        this.classList.add('active');
      }

      close() {
        pauseAllMedia();
        this.classList.remove('active');
      }

      zoomist() {
        this.zoomistInitialized = true;

        if (!window.ZoomistURL) return;

        const script = document.createElement('script');

        script.src = window.ZoomistURL;

        document.body.append(script);

        waitForElemObject('Zoomist', () => {
          const elements = this.querySelectorAll('.zoomist-container');

          elements.forEach(element => new Zoomist(element));
        });
      }
    }
  );
}
